var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "cursor-pointer",
    id: "_314eec5d0c2110d02c2df6c410efc994",
    "data-name": "314eec5d0c2110d02c2df6c410efc994",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24.521 24.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M3.583,24.524H18.941a3.594,3.594,0,0,0,3.583-3.6V13.211a1.024,1.024,0,0,0-2.048,0v7.717a1.544,1.544,0,0,1-1.536,1.549H3.583a1.544,1.544,0,0,1-1.536-1.549V5.6A1.544,1.544,0,0,1,3.583,4.048h7.679a1.024,1.024,0,1,0,0-2.048H3.583A3.594,3.594,0,0,0,0,5.6V20.928a3.594,3.594,0,0,0,3.583,3.6Z",
    transform: "translate(0 -0.033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M9.474,10.793l-.808,3.7a1.024,1.024,0,0,0,.277.943,1.063,1.063,0,0,0,.942.275l3.692-.81a1.024,1.024,0,0,0,.506-.277l9.331-9.331a3.071,3.071,0,0,0,0-4.344,3.143,3.143,0,0,0-4.343,0L9.755,10.29a1.024,1.024,0,0,0-.281.5ZM20.52,2.4a1.046,1.046,0,0,1,1.448,0,1.033,1.033,0,0,1,0,1.447l-.724.724L19.8,3.121Zm-9.112,9.126,6.936-6.953,1.433,1.441-6.939,6.955L11,13.37Z",
    transform: "translate(0.206 -0.079)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPage);
export default __webpack_public_path__ + "static/media/editPage.08949a455ea01bf6327dce4cb4315363.svg";
export { ForwardRef as ReactComponent };